const LOCALSTORAGE_KEY = "orchestrator_batch";
export const saveBatchId = (batchId, basePath) => {
    const data = { batchId, basePath };
    localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(data));
};
export const getBatchId = () => {
    const data = localStorage.getItem(LOCALSTORAGE_KEY);
    if (!data) {
        return null;
    }
    try {
        return JSON.parse(data);
    }
    catch {
        return null;
    }
};
export const clearBatchId = () => {
    localStorage.removeItem(LOCALSTORAGE_KEY);
};
